import { render, staticRenderFns } from "./PatientGroupManagement.vue?vue&type=template&id=052909fd"
import script from "./PatientGroupManagement.vue?vue&type=script&lang=js"
export * from "./PatientGroupManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports